import React, { useEffect, useState, useRef } from 'react'
import { LandingHeader } from './LandingHeader'
import { SimpleFooter } from '../footer/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthToken } from '../../hooks/useAuthToken';
import { useUserPlan } from '../../hooks/useUserPlan';
import { PLAN_TYPE_EAN_STUDENT_TACHER_COLLABORATOR } from '../../assets/constants';
import { AcceptDialog } from "../controls/UIControls";
const landingImages = require.context('../../assets/images', true);

export const LandingPage = () => {
    const navigate = useNavigate();
    const [eanuserDialog,setEanuserDialog] = useState(false);
    const {authToken, isLogged} = useAuthToken();
    const {checkUserPlan} = useUserPlan();
    const [eanActivePlan, setEanActivePlan] = useState(false);
    const [iframeHeight, setIframeHeight] = useState('200');
      const iframeRef = useRef(null);
      const ajustarAlturaIframe = () => {
        if (iframeRef.current) {
          const iframeWidth = iframeRef.current.offsetWidth;
          const aspectRatio = 9 / 16;
          const newHeight = Math.floor(iframeWidth * aspectRatio);
          setIframeHeight(`${newHeight}px`);
        }
      };
      useEffect(() => {
        ajustarAlturaIframe();
        const handleResize = () => {
          ajustarAlturaIframe();
        };
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
    useEffect(() => {
        window.scrollTo(0, 0);
        if(isLogged()) {
            checkUserPlan(authToken)
            .then (hasPlan => {
             if(hasPlan && hasPlan.planType==PLAN_TYPE_EAN_STUDENT_TACHER_COLLABORATOR) {
                     setEanActivePlan(true);
                 }
            });
           }
           }, []);

    const showEanDialog = e => {
        e.preventDefault();
        setEanuserDialog(true);
    }
    window.addEventListener('scroll', function(){
        if(this.window.scrollY>100){
            const elements = this.document.getElementsByClassName('landing__whatsapp-button-static')
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                element.classList.add("landing__whatsapp-button")
                element.classList.remove("landing__whatsapp-button-static")
            }
        }
    });
    return (
    <>
        <LandingHeader />
        <AcceptDialog 
          open={eanuserDialog}
          message="Ya disfrutas de un plan B2B."
          style='info'
          afterClose={()=>setEanuserDialog(false)}
            ></AcceptDialog>
        <div className='landing__container-eres-comunidad-eanista mt-5'>
            <div className='container my-5'>
                <div className='row justify-content-center align-items-center'>
                    <div className='col-12 d-block d-lg-none' style={{overflow: "hidden", textAlign: "center", margin: "0 auto"}}>
                        <iframe className="col-12" width="560" height="315" src="https://www.youtube.com/embed/4McWM-mF1w8?si=ReyazLDww5QSFHW9&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                    <div className='col-xl-5 col-12'>
                        <div className='row'>
                            <div className='col-12 landing__text-eres-comunidad-eanista'><span className='landing__text-color-green'>¡Vive la experiencia de Usuario EanX!</span>
                            </div>
                        </div>
                        <div className='row my-4'>
                            <div className='col-12 landing__paragraph-text'>
                            <p className='landing__text-color-dark-green'>Queremos que explores nuestra plataforma de cursos digitales de forma gratuita. Para empezar con esta aventura, solo debes ingresar con el correo <b>demo@eanx.co</b> y la clave <b>Demo1*</b>. Una vez dentro, podrás navegar en algunos de nuestros cursos sin compromiso.</p>

                            <p className='landing__text-color-dark-green'>Una vez te decidas, puedes adquirir cualquiera de nuestros planes desde <b>https://eanx.co/planes.</b></p>
                            <p className='landing__text-color-dark-green'>En EanX, te ofrecemos una experiencia de aprendizaje única, con cursos diseñados por expertos y una plataforma intuitiva y fácil de usar, ¡compruébalo tú mismx! </p>
                            <p className='landing__text-eres-comunidad-eanista_bold'>¡Bienvenidx a EanX!</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-7 pe-0 d-none d-lg-grid'>
                        <div className='justify-content-end ' style={{width: "95%"}}>
                            <div className='col-12' style={{padding: "0px"}}>
                                <iframe className="video-iframe" ref={iframeRef} width="100%" style={{ height: iframeHeight }} src="https://www.youtube.com/embed/4McWM-mF1w8?si=ReyazLDww5QSFHW9&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SimpleFooter />
    </>
  )
}
